import React, { Component } from 'react';
import Article from './Article';

class Podcast extends Component {

    componentDidMount() {
        this.props.articleRetrieval(73, undefined, 1, 'podcast');
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.key !== this.props.location.key) {
            this.props.articleRetrieval(73, undefined, 1, 'podcast');
        }
    }

    render() {
        return (
            <div className="wrapper podcast">
                <div className="loading-container">
                    <div className={this.props.loading ? 'loader loading' : 'loader'}>
                        <p>LOADING</p>
                    </div>
                </div>
                <div className="podcast-title-container">
                    <h2 className="podcast-title">The Reheat</h2>
                </div>
                <div className="podcast-description" dangerouslySetInnerHTML={{ __html: this.props.pod }}>
                </div>
                <div className={this.props.loading ? 'articleGrid loading' : 'articleGrid'}>
                    {this.props.articles.map((article) => {
                        return <Article key={article.id} title={article.content.rendered} link={article.Link} publication={article.Publication} image={article._embedded["wp:featuredmedia"] ? `${article._embedded["wp:featuredmedia"]["0"].source_url}` : ''} date={article.date} />
                    })}
                </div>
            </div>
        );
    }
}

export default Podcast;
